export default __webpack_public_path__ + "static/media/movie_recommender.6bcb5d1c.PNG";